__turbopack_context__.v({
  "ArrowIcon": "QrX7RW_ArrowIcon",
  "Button": "QrX7RW_Button",
  "CountryName": "QrX7RW_CountryName",
  "Desktop": "QrX7RW_Desktop",
  "DisableMobile": "QrX7RW_DisableMobile",
  "Flowmap": "QrX7RW_Flowmap",
  "Item--Active": "QrX7RW_Item--Active",
  "List": "QrX7RW_List",
  "Mobile": "QrX7RW_Mobile",
  "NoMatch": "QrX7RW_NoMatch",
  "Root": "QrX7RW_Root",
  "Search": "QrX7RW_Search",
  "SearchInput": "QrX7RW_SearchInput",
  "skeleton-loading": "QrX7RW_skeleton-loading",
});
